module.exports = __webpack_public_path__ + "img/distance.318f6347.svg";